const log = require("../shared_utils/log.js");
const gameStep = require("./utils/game-step.js");
const { handleMessages } = require("./utils/arcade-vm-hooks");
const { sanitizeVariables } = require("./utils/sanitize-state.js");
const { getGlitchesAppliedToTarget } = require("./utils/glitch-helpers.js");

const VM_INTERVAL = 33;

module.exports = function scratchvm(state, emitter) {
  emitter.on("destroy-target", (targetId) => {
    const target = state.vm.runtime.targets.find((t) => t.id === targetId);
    const spriteName = target.sprite.name;
    emitter.emit("piece-destroyed", spriteName);
  });

  emitter.on("start-vm", () => {
    log("start-vm");
    clearInterval(state.vmInterval);
    state.vm.runtime._cloneCounter = -10000;
    state.vmInterval = setInterval(() => {
      emitter.emit("game-step");
    }, VM_INTERVAL);
    const node = state.vm.runtime.audioEngine.getInputNode();
    const volPercent = state.masterVolume / 100;
    const gain = volPercent * volPercent;
    node.gain.setValueAtTime(gain, 0);
    state.vm.runtime.ioDevices.keyboard._keysPressed = [];
    state.vm.runtime.triggerCollisionSound = function triggerCollisionSound(
      targetA,
      targetB
    ) {
      const soundToPlay = getCollisionSound(targetA, targetB);
      if (soundToPlay) {
        const sound = state.soundLibrary[soundToPlay];
        const spriteSound = targetA.sprite.sounds.find(
          (s) => s.name === sound.name
        );
        targetA.sprite.soundBank.playSound(targetA, spriteSound.soundId);
      } else {
        console.log("No sound to play for collision between", targetA, targetB);
      }
    };
    emitter.emit("render");
  });

  function getCollisionSound(targetA, targetB) {
    const glitchesA = getGlitchesAppliedToTarget(
      targetA,
      state.glitchApplications
    );
    const glitchesB = getGlitchesAppliedToTarget(
      targetB,
      state.glitchApplications
    );

    if (glitchesA.includes("hazard") || glitchesB.includes("hazard") ||
        glitchesA.includes("walk") || glitchesB.includes("walk")) {
      return null;
    } else {
      const targetAKickStrength = Object.values(targetA.variables).find(
        (v) => v.name === "kickStrength"
      );
      const targetBKickStrength = Object.values(targetB.variables).find(
        (v) => v.name === "kickStrength"
      );
      if (
        (targetAKickStrength > 0 && targetBKickStrength > 0) ||
        glitchesA.includes("bouncify") ||
        glitchesB.includes("bouncify")
      ) {
        return "bounce";
      } else {
        return "collide";
      }
    }
  }

  emitter.on("stop-vm", () => {
    log("stop-vm");
    if (state.vm && state.vmInterval) {
      clearInterval(state.vmInterval);
      state.vm.runtime.ioDevices.keyboard._keysPressed = [];

      setTimeout(() => {
        if (!state.isGamePlaying) {
          const node = state.vm.runtime.audioEngine.getInputNode();
          node.gain.setValueAtTime(0, 0);
        }
      }, 2000);
    }
  });

  emitter.on("game-step", () => {
    setGhostToMax(state, 99);
    sanitizeVariables(state);
    state.vm = gameStep(state.vm, state.glitchApplications);
    handleMessages(state.vm, emitter);
    emitter.emit("render");
  });
};

function setGhostToMax(state, max) {
  state.vm.runtime.targets
    .filter((t) => !t.isStage)
    .forEach((target) => {
      if (target.effects.ghost > max) {
        target.setEffect("ghost", max);
      }
    });
}
